//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const pointCardStyles = makeStyles((theme) => ({
    cardParentGrid: {
        padding: "0px 40px",
        fontFamily: "segoe-ui",
        marginTop: 50,
        "@media (max-width: 600px)": {
            padding: 10,
        },
    },
    cardChildGrid: {
        "@media (max-width: 600px)": {
            padding: "10px 0",
        },
    },
    appBarText: {
        fontSize: 34,
        verticalAlign: "middle",
        "@media (max-width: 600px)": {
            fontSize: 22,
        },
    },
    border: {
        borderRadius: 20,
        cursor: "pointer",
        "@media (min-width: 1280px)": {
            margin: "0px",
            padding: 20,
            borderBottom: "none",
        },
    },
    grid: {
        marginBottom: "15%",
        "@media (min-width: 1280px)": {
            marginBottom: "5%",
        },
    },
    wordBreak: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        display: "table",
        width: "100%",
        tableLayout: "fixed",
    },
    card: {
        backgroundColor: "#f6f9fc",
        borderRadius: 15,
        padding: 10,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },

    cardCompact: {
    backgroundColor: "#f6f9fc",
    borderRadius: 15,
    padding: "15px 10px 10px 10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    boxSizing: "border-box",
     height: "auto",
},
    pointsText: {
        fontSize: "1.125rem",
        fontWeight: "bold",
        color: "#58595b",
        width: "100%",
        display: "inline-block"
    },
    pointsValue: {
        fontSize: "1.25rem",
        fontWeight: "bold",
        color: "#000"
    },
    dialogParentDiv: {
        padding: 16,
      },
      parentText: {
        fontSize: 18,
        fontWeight:"bold"
        
    },
    emptyDataText: {
        textAlign: "center",
        fontSize: 20,
        fontFamily: "segoe-ui",
        padding: "5%",
        marginTop:"30px",
        marginRight:"20px"
      },
      emptyDataIcon: {
        fontSize: 50,
        textAlign: "center",

      },

      redeemnew : {
         marginTop: 12,
        background: "#0866c6",
        color: "#fff",
        border: "none",
        borderRadius: "20px",
        padding: "9px 25px",
        fontSize: "15px",
        fontWeight: 600,
        cursor: "pointer",
      },

      
      "makeStyles-emptyDataText": {},
      errorMsg: {
        color: "#606060",
      },

     
}));